@if (visible()) {
  <div
    class="fixed inset-0 z-drawer flex items-center justify-center bg-black/40"
    (click)="close()"
  >
    <div
      class="bg-white dark:bg-gray-900 rounded-xl shadow-2xl p-6 w-full max-w-md mx-4"
      (click)="$event.stopPropagation()"
    >
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">
        Completar tarea
      </h3>

      <p class="text-sm text-gray-500 dark:text-gray-400 mb-3 truncate">
        {{ task()?.title }}
      </p>

      <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">
        Nota final (opcional)
      </label>

      <textarea
        [value]="notes()"
        (input)="onNotesChange($event)"
        rows="3"
        placeholder="Ej. resultado de la gestión, próximos pasos..."
        class="w-full text-sm rounded-md border border-gray-300 bg-white text-gray-900 placeholder:text-gray-400 dark:bg-gray-800 dark:border-gray-700 dark:text-white px-3 py-2 mb-4"
      ></textarea>

      <div class="flex justify-end gap-2">
        <button
          (click)="close()"
          class="px-4 py-2 text-sm rounded-md border border-gray-300 dark:border-gray-700"
        >
          Cancelar
        </button>
        <button
          (click)="confirm()"
          class="px-4 py-2 text-sm rounded-md bg-success-500 text-white hover:bg-success-600"
        >
          Completar
        </button>
      </div>
    </div>
  </div>
}
